/*
 * Copyright (c) Nexign, JSC, 2021-2022.
 */
/**
 * Page Account Info Styled
 *
 * @author Aleksandr Perkhunov
 * @author Yakov Gushchin
 * @author Evgeniy Naumov
 * @version 1.22.0
 * @since 1.10.0
 */

import styled from 'styled-components';

import { ImgStyled } from '@components/common/Block/Img';
import { colors, fonts } from '@theme/index';

export const PageAccountDateContainderStyled = styled.div`
    display: flex;
    height: 32px;
    flex-direction: row;
    align-items: center;
    padding-top: 2px;
    margin-left: 8px;
`

export const PageAccountInfoStyled = styled.div`
    position: relative;
    display: flex;
    flex-direction: column;
    flex-grow: 1;
`;

export const PageAccountInfoBodyStyled = styled.div`
    display: grid;
    grid-template-columns: 285px 1fr;
    grid-template-rows: auto 1fr;
    grid-template-areas: "account-side-menu account-notice" "account-side-menu account-content";

    flex-grow: 1;
    position: relative;

    border-top: 1px solid ${colors.borderColorDisabled};

    .notice-error {
        max-height: 32px;
    }
`;

export const PageAccountInfoSideStyled = styled.div.attrs({
    'data-name': 'account',
})`
    grid-area: account-side-menu;

    & .side-menu {
        border-top: none;
    }
`;

export const PageAccountInfoContentStyled = styled.div.attrs({
    'className': 'page-account-info__content',
    'data-name': 'page-account-info-content',
})`
    grid-area: account-content;

    position: relative;

    padding-left: 28px;
    flex-grow: 1;

    margin-top: 32px;
    margin-bottom: 108px;
`;

export const PageAccountInfoTitleStyled = styled.div.attrs({
    className: 'page-account-info__title',
})`
    margin-bottom: 32px;
    ${fonts.textHeader3};
`;

export const PageAccountInfoSyncDateStyled = styled.div.attrs({
    className: 'page-account-info__sync-date',
})`
    display: flex;
    align-items: center;
    ${fonts.textSmall};
    color: ${colors.textColorOpacity};
    gap: 6px;

    ${ImgStyled} {
        margin-left: 8px;
        cursor: pointer;
    }
`;

export const PageAccountInfoEmptyStyled = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;

    & .page-account-info__text {
        margin-top: 16px;
        ${fonts.textHeader3};
    }
`;
